<template>
    <div class="subscription-condition-management mb-5">
        <div class="row">
            <div class="col-12">
                <h3 class="mb-4">{{ $t('cdb.subscriptions.conditions') }}</h3>
            </div>
            <div class="col-12 col-xl-6 mb-3 px-0">
                <data-entry-column :title="$t('cdb.subscriptions.price_of_months')" :value="getPrice"
                    :full-width="true"></data-entry-column>
            </div>
            <div class="col-12 col-xl-6 mb-3 px-0">
                <data-entry-column :title="$t('cdb.subscriptions.mileage')" :full-width="true">
                    <template v-slot:value>
                        <p>
                            {{ $n(pricePlan.mileage, 'number') }} {{getMileage}}/{{ $t('pds.buy_box.month')}}
                        </p>
                    </template>
                    <template v-slot:action>
                        <span v-if="mileageEditable" class="text-link" @click="openChangeKilometerPackageModal">
                            {{ $t('cdb.subscriptions.change') }}
                        </span>
                    </template>
                </data-entry-column>
            </div>
            <div class="col-12 col-xl-6 mb-3 px-0">
                <data-entry-column :title="$t('cdb.subscriptions.additional_mileage')"
                    :value="getAdditionalMileageCosts" :full-width="true"></data-entry-column>
            </div>
            <div class="col-12 col-xl-6 mb-3 px-0">
                <data-entry-column :title="$t('cdb.subscriptions.duration')" :full-width="true">
                    <template v-slot:value>
                        <p>{{pricePlan.duration}} {{ $t('cdb.subscriptions.months') }}</p>
                        <p v-if="hasSubscriptionEndDate">{{ subscriptionPeriod[0] }} – {{ subscriptionPeriod[1] }}</p>
                    </template>
                    <!--                    TODO: re-implement when ready-->
                    <!--                    <template v-slot:action>-->
                    <!--                        <span class="text-link" @click="openChangeDurationModal">Ändern</span>-->
                    <!--                    </template>-->
                </data-entry-column>
            </div>
            <div class="col-12 col-xl-6 mb-3 px-0">
                <data-entry-column :title="$t('pds.listing_price.title')" :value="getListingPrice"
                    :full-width="true"></data-entry-column>
            </div>
            <div class="col-12 col-xl-6 mb-3 px-0">
                <data-entry-column :title="$t('cdb.subscription.car_return.mileage_at_handover')"
                    :value="currentMilesFormatted" :full-width="true"></data-entry-column>
            </div>
            <div class="col-12 col-xl-6 mb-3 px-0" v-if="getTotalBookedMileage > 0">
                <div class="col-12 col-xl-6 mb-3 px-0">
                    <data-entry-column
                        :title="$t('cdb.subscription.car_return.inclusive_mileage_current_billing_period')"
                        :value="totalBookedMileageFormatted" :full-width="true"></data-entry-column>
                </div>
                <div class="col-12 col-xl-6 mb-3 px-0">
                    <data-entry-column
                        :title="$t('cdb.subscription.car_return.total_allowed_mileage_current_billing_period')"
                        :value="totalMileageAllowedOnVehicleFormatted" :full-width="true"></data-entry-column>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../../event-bus';
import DataEntryColumn from "../atoms/DataEntryColumn.vue";

export default {
    name: 'SubscriptionConditionManagement',
    components: {
        DataEntryColumn,
    },
    props: {
        subscriptionData: {
            type: Object,
            required: true
        },
        pricePlan: {
            type: Object,
            required: true
        },
        additionalMileageCosts: {
            type: Object,
            required: true
        },
        timestamps: {
            type: Object,
            required: true
        },
        hasSubscriptionEndDate: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        openChangeDurationModal(){
            EventBus.$emit('init-change-duration', {todo: true});
        },
        openChangeKilometerPackageModal(){
            EventBus.$emit('init-change-kilometer-package', {subscription: this.subscriptionData});
        },
    },
    computed: {
        withoutTax() {
            return this.$root.whitelabel.setting('show_price_without_taxes')
        },
        subscriptionPeriod() {
            const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
            return [
                this.$d(new Date(this.timestamps.contract_started_at * 1000), 'short'),
                this.$d(new Date(this.timestamps.cancel_to * 1000), 'short')
            ]
        },
        getAdditionalMileageCosts(){
            if(this.additionalMileageCosts) {
                const costs = this.withoutTax ? this.additionalMileageCosts.net_costs : this.additionalMileageCosts.costs
                const taxes = this.withoutTax ? this.$t('general.net') : ''
                return `${this.$root.whitelabel.getFormatetPrice(costs)} ${taxes}`
            }
            return ''
        },
        mileageEditable() {
            const { status  } = this.subscriptionData
            if((status === 'SUBSCRIPTION_ACTIVE' || status === 'SUBSCRIPTION_CUSTOMER_CANCELLATION') && this.subscriptionData.type != 'MVS') {
                return true
            } else {
                return false
            }
        },
        getListingPrice() {
            return this.$root.whitelabel.getFormatetPrice(
                this.subscriptionData.vehicle.listing_price
            )

        },
        getMileage() {
            return `${this.$root.whitelabel.getMileageUnit()}`
        },
        getPrice() {
            if(this.pricePlan){
                const showPricesWithoutTaxes = this.$root.whitelabel.setting('show_price_without_taxes')
                const price = showPricesWithoutTaxes ? this.pricePlan.price_without_tax : this.pricePlan.price
                const priceAppend = showPricesWithoutTaxes ?  this.$t('cdb.subscriptions.exclusiveVat') : ''
                return `${this.$root.whitelabel.getFormatetPrice(price)} ${priceAppend}`
            }
            return ''
        },
        currentMilesFormatted() {
            return this.$n(this.subscriptionData.current_miles, { style: 'unit', unit: 'kilometer' })
        },
        totalBookedMileageFormatted() {
            return this.$n(this.subscriptionData.total_booked_mileage, { style: 'unit', unit: 'kilometer' })
        },
        totalMileageAllowedOnVehicleFormatted() {
            return this.$n(this.subscriptionData.total_mileage_allowed_on_vehicle, { style: 'unit', unit: 'kilometer' })
        },
        getTotalBookedMileage() {
            return this.subscriptionData.total_booked_mileage ?? 0
        }
    }
}
</script>

<style scoped lang="scss"></style>
